import { render, staticRenderFns } from "./BottomMenuMob.vue?vue&type=template&id=785fb1a6&scoped=true&"
import script from "./BottomMenuMob.vue?vue&type=script&lang=js&"
export * from "./BottomMenuMob.vue?vue&type=script&lang=js&"
import style0 from "./BottomMenuMob.vue?vue&type=style&index=0&id=785fb1a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785fb1a6",
  null
  
)

export default component.exports